import React from 'react';
import Dropzone from 'react-dropzone';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import Circle from '@atoms/Circle';
import { ErrorText, LabelLarge, PhotoUploadWrapper } from '@styled';
import colors from '@general/colors';

const TitleBanner = styled.div`
    background-color: ${colors.lightGray};
    bottom: 0;
    left: 0;
    overflow: hidden;
    padding: 9px 12px;
    position: absolute;
    width: 100%;
`;

const PhotoUpload = ({
    title,
    banner = false,
    multiple = false,
    maxSize,
    maxFiles,
    fileTypes,
    onDrop,
    hasError = false,
}) => (
    <PhotoUploadWrapper>
        <Dropzone accept={fileTypes} maxSize={maxSize} maxFiles={maxFiles} multiple={multiple} onDrop={onDrop}>
            {({ getRootProps, getInputProps }) => (
                <div
                    className="d-flex flex-column justify-content-center align-items-center border-light-gray border-dashed cursor-pointer h-100"
                    {...getRootProps()}
                >
                    <div>
                        <input {...getInputProps()} />
                        <Circle
                            backgroundColor="#F5F5F5"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <FontAwesomeIcon icon={faPlus} size="lg" />
                        </Circle>
                    </div>

                    {!banner ? (
                        <div className="mt-0.625rem">
                            <LabelLarge className="mt-1">{title}</LabelLarge>
                        </div>
                    ) : (
                        <>
                            <div className="mt-0.625rem">&nbsp;</div>

                            <TitleBanner>
                                <LabelLarge>{title}</LabelLarge>
                            </TitleBanner>
                        </>
                    )}
                </div>
            )}
        </Dropzone>

        <div>
            {hasError && (
                <div className="mt-3">
                    <ErrorText>There was an error uploading your image. Try another file.</ErrorText>
                </div>
            )}
        </div>
    </PhotoUploadWrapper>
);

PhotoUpload.propTypes = {
    title: PropTypes.string,
    banner: PropTypes.bool,
    multiple: PropTypes.bool,
    fileTypes: PropTypes.string,
    maxSize: PropTypes.number,
    maxFiles: PropTypes.number,
    onDrop: PropTypes.func,
    hasError: PropTypes.bool,
};

export default PhotoUpload;
